import React, { useCallback, useEffect } from 'react'
import { actionCreators as localizeActions } from '@/store/Localize'
import LoadingIndicator from '@/components/LoadingIndicator'
import { useDispatch } from '@/hooks/dispatch'
import { useReduxState } from '@/hooks/reduxState'

const LocalizationContext = React.createContext()

const LocalizationProvider = ({ children }) => {
  const value = useReduxState(useCallback((state) => state.localization, []))
  return <LocalizationContext.Provider value={value}>{children}</LocalizationContext.Provider>
}

const LocalizationLoader = ({ children }) => {
  const [load] = useDispatch([localizeActions.loadResources])
  const ready = useReduxState(useCallback(state => !!state.localization.data, []))
  useEffect(() => load(), [load])
  return ready ? children : <LoadingIndicator />
}

export {
  LocalizationContext,
  LocalizationProvider,
  LocalizationLoader
}



// WEBPACK FOOTER //
// ./src/components/localization.js